const state = {
  contractData: [],
  formalContractData: []
}

const mutations = {
  // 保存合同数据
  SET_CONTRACTDATA: (state, val) => {
    state.contractData = val
  },
  // 清空合同数据
  EMPTY_CONTRACTDATA: (state, val) => {
    state.contractData = val
  },

  // 保存正式合同数据
  SET_FORMALCONTRACTDATA: (state, val) => {
    state.formalContractData = val
  },
  // 清空正式合同数据
  EMPTY_FORMALCONTRACTDATA: (state, val) => {
    state.formalContractData = val
  }
}

const actions = {
  // 保存合同数据
  chengeContractadta({ commit }, data) {
    commit('SET_CONTRACTDATA', { contractData: data.contractData })
  },
  // 清空合同数据
  clearContractadta({ commit }) {
    commit('EMPTY_CONTRACTDATA', [])
  },

  // 保存合同数据
  chengeFormalContractData({ commit }, data) {
    commit('SET_FORMALCONTRACTDATA', { formalContractData: data.formalContractData })
  },
  // 清空合同数据
  clearFormalContractData({ commit }) {
    commit('EMPTY_FORMALCONTRACTDATA', [])
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
